import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import DefaultCard from '../../../components/default/DefaultCard';
import usePaymentStatusDetailService from '../../../app/services/hooks/usePaymentStatusDetailService';
import { PaymentStatusDetailDataForm, PaymentStatusDetailFilters } from '../../../app/models/PaymentStatusDetail';
import PaymentStatusDetailDataTable from './tables/PaymentiStatusDetailTable';
import PaymentStatusSummaryTable from './tables/PaymentStatusSummaryTable';
import { PaymentStatusSummary } from '../../../app/models/PaymentStatusSummary';


interface Props {
    paymentStatusId: number;
    isShow?: boolean;
    paymentStatusCurrency?: string;
    reloadTrigger?: number;
}

const PaymentStatusDetailContainer = ({
    paymentStatusId,
    paymentStatusCurrency,
    reloadTrigger,
}: Props) => {
    const {
        getPaymentStatusDetailsByPaymentStatus,
        fetchingGetPaymentStatusDetailByPaymentStatus,
        getPaymentStatusSummary,
        fetchingGetPaymentStatusSummary,
    } = usePaymentStatusDetailService();

    const [paymentStatusDetails, setPaymentStatusDetails] = useState<PaymentStatusDetailDataForm[]>([]);
    const [totalRows, setTotalRows] = useState<number>(0);
    
    const [paymentStatusSummaries, setPaymentStatusSummaries] = useState<PaymentStatusSummary[]>([]);
    const [viewMode, setViewMode] = useState<'detail' | 'summary'>('summary');
    
    const [filter, setFilter] = useState<PaymentStatusDetailFilters>({
        page: 1,
        per_page: 10,
        sort: 'position',
        order: 'desc'
    });

    useEffect(() => {
        if (viewMode === 'detail') {
            reloadTable();
        } else {
            loadSummary();
        }
    }, [filter, viewMode]);

    useEffect(() => {
        if (reloadTrigger && reloadTrigger > 0) {
            if (viewMode === 'detail') {
                reloadTable();
            } else {
                loadSummary();
            }
        }
    }, [reloadTrigger]);

    const reloadTable = () => {
        getPaymentStatusDetailsByPaymentStatus(filter, paymentStatusId, {
            onSuccess: (response: ServiceResponse) => {
                setPaymentStatusDetails(response.data.payment_status_details);
                setTotalRows(response.data.total_rows);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    };

    const loadSummary = () => {
        getPaymentStatusSummary(paymentStatusId, {
            onSuccess: (response: ServiceResponse) => {
                setPaymentStatusSummaries(response.data.summaries || []);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    };

    const toggleViewMode = () => {
        setViewMode(viewMode === 'detail' ? 'summary' : 'detail');
    };

    return (
        <>
            <DefaultCard>
                <div className="row">
           
                    <div className="col-12 mb-2">
                        <div className="d-flex justify-content-end">
                            <button 
                                className="btn btn-primary btn-sm"
                                onClick={toggleViewMode}
                            >
                                <i className={`mdi ${viewMode === 'detail' ? 'mdi-view-list' : 'mdi-view-grid'} mr-1`}></i>
                                {viewMode === 'detail' ? 'Ver Resumen' : 'Ver Detalle'}
                            </button>
                        </div>
                    </div>
              
                    <div className="col-12">
                        {viewMode === 'detail' ? (
                            <PaymentStatusDetailDataTable
                                paymentStatusDetails={paymentStatusDetails}
                                totalRows={totalRows}
                                filter={filter}
                                setFilter={setFilter}
                                loading={fetchingGetPaymentStatusDetailByPaymentStatus}
                                paymentStatusCurrency={paymentStatusCurrency}
                            />
                        ) : (
                            <PaymentStatusSummaryTable
                                summaries={paymentStatusSummaries}
                                loading={fetchingGetPaymentStatusSummary}
                                paymentStatusCurrency={paymentStatusCurrency}
                            />
                        )}
                        
                    </div>
                </div>
            </DefaultCard>
        </>
    );
};

export default PaymentStatusDetailContainer;
